module.exports = __webpack_public_path__ + "images/emoji/expressionless.ab8ee191f4eabbc60879.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/expressionless.png
// module id = Fe6T
// module chunks = 24